module.exports = __webpack_public_path__ + "static/img/snail_ani.fd53117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/snail_ani.png
// module id = ZZ5E
// module chunks = 1 3